


/* global _E, dinStyle, Q, theIframe */






/* PHP tesster */
(function(){ 
testPHP = function(src) {
    var x=theIframe.contentDocument.body;
    x.innerHTML = '';
    theIframe.contentDocument.body.appendChild(loader.cloneNode(true));
    hidden_snipet.value = encodeURI(src.replace(/(<\/li.*?>|<br.*?>)/gim, '\n\r')
            .replace(/<[^<]*?>/gim, '').
            replace(/&nbsp;/gim, ' ').
            trim());
   Q.ajax({
         src:"test_php_snipet.php",
         method:"POST",
         data:php_form,
         cb:function(rsp){             
                     x.innerHTML="<div style='padding:5px;max-width:440px;overflow:auto;max-height:100%;-webkit-overflow-scrolling: touch;'>"+rsp+"</div>"; 
            x.style.margin=0;     
            theIframe.style.height=Math.max(100,Math.min(x.firstChild.scrollHeight,400))+"px";
         }
    });
};

var loader = _E();
loader.innerHTML = "<img src='/aha/img/loader.gif' >";
var php_form = _E('form');
var hidden_snipet = _E('input');
hidden_snipet.name = "snipet";
php_form._(hidden_snipet);

var php_holder = _E();
php_holder.css("max-height:400px;position:absolute;visibility:hidden;top:-600px;left:0;zIndex=1000");
//php_holder.drag();
var php_holder_head = _E('div', 'result').css('cursor:move;font-weight:bold;text-align:center;background:rgba(100,100,255,.9);color:white;margin-bottom:3px;padding:3px ;');
php_holder._(php_holder_head);
php_holder_head.dragParent();
php_res_hider = _E('kill');
php_res_hider.css('position:absolute;top:-.2em;padding:0;background:transparent;left:2px;font-size:1.6em;color:white');
 
php_res_hider.on('click,touchstart', function() {
    php_holder.style.display = 'none';
    //theIframe.style.display = 'none';
}, false);
php_holder._top(php_res_hider);


theIframe = _E('iframe').setA({scrolling:"no", 
        seamless:"seamless"});
theIframe.css('background:white;width:440px ;visibility:hidden;overflow-y: hidden !important;');

php_holder._(theIframe);



 try_php_code=function(elm) {
    var ez = elm.parentNode.parentNode.childNodes[1];
    if (elm.innerText === 'edit') {    
        elm.innerText = 'reset';
        ez.store_original_code = ez.innerHTML;
        ez.setA('contenteditable', true).setA('spellcheck', false);
    }
    else {
        ez.innerHTML = ez.store_original_code;
    }
    ez.focus();
};



run_php_code=function (elm) {
    //if(window['php_tester'])php_tester.style.visibility='hidden';
    var code_elm = elm.parentNode.parentNode.childNodes[1];
    var code = code_elm.innerHTML;
    testPHP(code);
    theIframe.style.visibility = 'visible';
    php_holder.style.visibility = 'visible';
    php_holder.style.display = 'block';
    php_holder.slideY(elm.y).slideX(elm.x + 60);
};
charge_cmdLine=function (elm) {
    var code = elm.parentNode.parentNode.childNodes[1].innerText;
    
   // code = code.replace(/(<li.*?>|<br.*?>)/gim, '\n').replace(/<[^<]*?>/gim, '').replace(/&nbsp;/gim,"").replace("/(&amp;)/gim",function(x){console.log(x)}).trim();
    //code=code.replace(/&lt;/gim,"<").replace(/&gt;/gim,'>').replace(/&nbsp;/gim,' ');
    try{eval(code);}catch(e){dn(e,"SyntaxError");}
};

window.addEventListener('load', function() {
    document.body._(php_holder);
}, false);
})();










////

runSnipet = function(elm) {
    var cod = elm.innerHTML.replace(/<cmt.*?>.*?<\/cmt>/gim, '').replace(/<.*?>/gim, '').replace(/&/gim, '&');
    eval(cod);
    if (arguments[1] !== undefined) {
        elm.css('opacity:.9;position:relative;color:gray').onclick = '';
        elm._(_E('', 'done').css('position:absolute;left:400px;color:green;font-size:.8em'));
    }
};

        
